var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1 20.654V18C11.1 17.5029 11.5029 17.1 12 17.1C12.4971 17.1 12.9 17.5029 12.9 18V20.654C16.9861 20.2341 20.2341 16.9861 20.654 12.9H18C17.5029 12.9 17.1 12.4971 17.1 12C17.1 11.5029 17.5029 11.1 18 11.1L20.654 11.1C20.2341 7.01386 16.9861 3.76594 12.9 3.34599V6C12.9 6.49706 12.4971 6.9 12 6.9C11.5029 6.9 11.1 6.49706 11.1 6V3.34599C7.01386 3.76594 3.76594 7.01386 3.34599 11.1L6 11.1C6.49706 11.1 6.9 11.5029 6.9 12C6.9 12.4971 6.49706 12.9 6 12.9H3.34599C3.76594 16.9861 7.01386 20.2341 11.1 20.654ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.d60d2cb56850a66e70ec854f3dc45e25.svg";
export { ForwardRef as ReactComponent };